import { isApp, isPC, isTg } from './tools';
import { toFormat } from './number';

// 平台判断
export const usePlat = () => {
  let plat = '';
  let isPCPlat = false;
  let isH5Plat = false;
  let isAppPlat = false;
  let isTgPlat = false;
  if (isTg()) {
    plat = 'tg';
    isTgPlat = true;
  } else if (isApp()) {
    plat =  'app';
    isAppPlat = true;
  } else if (isPC()) {
    plat =  'pc';
    isPCPlat = true;
  } else {
    plat = 'h5';
    isH5Plat = true;
  }
  return { plat, isApp: isAppPlat, isPC: isPCPlat, isH5: isH5Plat, isTg: isTgPlat };
};

// 数字处理
export const useNumber = () => {
  return {
    toFormat
  };
};
